import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';

const QrCodeGenerator = ({ value }) => {
  return (
    <div style={{ background: 'white', padding: '16px' }}>
      <QRCodeCanvas
        value={value}
        size={256}                // Size of the QR Code in pixels
        bgColor={"#ffffff"}       // Background color
        fgColor={"#000000"}       // Foreground (QR) color
        level={"H"}               // Error correction level: L, M, Q, H
        includeMargin={true}      // Include a white margin around the code
        // imageSettings={{
        //   src: "https://upload.wikimedia.org/wikipedia/commons/a/a7/React-icon.svg",
        //   x: undefined,           // Center horizontally
        //   y: undefined,           // Center vertically
        //   height: 24,
        //   width: 24,
        //   excavate: true,         // 'Digs' out the center so the logo isn't covered by dots
        // }}
      />
    </div>
  );
};

export default QrCodeGenerator;